import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { UseHeader, MktButton, ResultAlert, CouponItem } from '@cps'
import { memberMobx, virtualOrderMobx } from '@mobxStore'
import { useHistoryNew, getCouponsInfo, modalLayer } from '@utils'
import ActivityApi from '@api/activity.api'
import { format } from '@dt/fe-utils'
import mktController from 'controllers/mktController'
import OrderProduct from '../components/OrderProduct'
import i18n from 'i18next'
import { each, keyBy } from '@dt/fe-utils/dist/lodash'
import MemberApi from '@api/member.api'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const GiftCard: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { orderNo } = match.params as any
  const [orderInfo, setOrderInfo] = useState<any>({})
  const [info, setInfo] = useState<any>(null)
  const [replyArr, setReplyArr] = useState<any[]>([])
  const [notCoupons, setNotCoupons] = useState<any[]>([])
  const [couponMap, setCouponMap] = useState<any>({})

  const goBack = () => {
    mktController.goBack(history)
  }

  const getComment = () => {
    MemberApi.getCommentDetail({
      sendPersonId: memberMobx.memberInfo.memberId,
      sendPersonType: 'member',
      outNo: orderNo,
      outType: 'orders'
    }).then((res: any) => {
      if (!res.error) {
        setInfo(res.detail)
        setReplyArr(res.replyInfos)
        const couponArr: any = []
        const notArr: any = []
        each(res.replyInfos, (item: any) => {
          if (item.coupons) {
            couponArr.push(...item.coupons)
          }
          if (item.coupons && !item.couponHasAcquired) {
            notArr.push(...item.coupons)
          }
        })
        setNotCoupons(notArr)
        if (couponArr.length > 0) {
          ActivityApi.getCouponsList({ couponIds: getCouponsInfo(couponArr) }).then((res: any) => {
            if (res?.length > 0) {
              setCouponMap(keyBy(res, 'couponId'))
            }
          })
        }
      }
    })
  }

  const getCoupons = () => {
    mktController.checkLogin(history).then(() => {
      memberMobx.acquiredCouponList({
        outType: 'comment',
        outNos: replyArr.map((item: any) => item.memberCommentId)
      }).then((res: any) => {
        if (res) {
          setNotCoupons([])
          modalLayer(ResultAlert, {
            title: i18n.t('mkt.coupon.receivedSucc'),
            btnTitle: i18n.t('mkt.common.toUse'),
            children: notCoupons.map((item: any, index: number) => {
              return couponMap[item.couponId] && (
                <div className='coupon-block' key={item.couponId}>
                  <CouponItem type='get' couponInfo={couponMap[item.couponId]} cnt={item.couponCnt > 1 ? item.couponCnt : ''}></CouponItem>
                </div>)
            })
          }).then(() => {
            history.push('/menu')
          }).catch(() => { })
        }
      })
    })
  }

  useIonViewWillEnter(() => {
    mktController.checkLogin(history, true, false).then(() => {
      virtualOrderMobx.getOrderDetail(orderNo).then((res: any) => {
        setOrderInfo(res)
      })
    })
  })

  useEffect(() => {
    getComment()
  }, [memberMobx.unacquiredCoupons])
  return (
    <IonPage className='eval-page'>
      <UseHeader title={i18n.t('pageName.evaluate')} onBack={goBack}></UseHeader>
      <IonContent className='page-content'>
        <div className='page-body'>
          <OrderProduct orderInfo={orderInfo}></OrderProduct>
          {
            info &&
              <div className='eval-con'>
                <div className='top-area'>
                  <div className='left'>
                    <div className='title'>{i18n.t('mkt.comment.mealEval')}</div>
                    <div className='des'>{format.toDateTime(info.addTime)}</div>
                  </div>
                  <div className='right'>
                    {
                      info.score === 5 ? (
                        <div
                          className='zan-item selected'
                        >
                          <i className='iconfont icon-zan'></i>
                        </div>
                      ) : (
                        <div
                          className='zan-item bad selected'
                        >
                          <i className='iconfont icon-zan'></i>
                        </div>
                      )
                    }
                  </div>
                </div>
                <div className={`message-area ${!info.at.includes('boss') && !info.medias.length ? 'bottom' : ''}`}>
                  <div className='message-show'>
                    {
                      info.at.map((item: any) => {
                        return <span key={item} className='tag'>@{i18n.t(`mkt.common.${item}`)}</span>
                      })
                    }
                    <span>{info.message}</span>
                  </div>
                </div>
                <div className='upload-area'>
                  <div className='upload-img'>
                    {
                      info.medias.map((item: any, index: number) => {
                        return (
                          <div key={index} className='img-item' style={{ backgroundImage: `Url(${item.url})` }}>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
                {
                  info.at.includes('boss') &&
                    <div className='footer-area'>
                      <div className='at-boss-tip'>{i18n.t('mkt.comment.evalSuccTip')}</div>
                    </div>
                }
              </div>
          }
          {
            replyArr.map((item: any, index: number) => {
              return (
                <div className='eval-con' key={index}>
                  <div className='top-area'>
                    <div className='left'>
                      <div className='title'>{i18n.t('mkt.comment.reply')}</div>
                      <div className='des'>{format.toDateTime(item.addTime)}</div>
                    </div>
                    <div className='right'></div>
                  </div>
                  {item.message && <div className='reply-area'>{item.message}</div>}
                  {item.coupons && item.coupons.length > 0 &&
                    <div className='coupon-area'>
                      {
                        item.coupons.map((c: any, cIndex: number) => {
                          const couponInfo: any = couponMap[c.couponId]
                          return couponInfo ? (
                            <div className='coupon-item' key={cIndex}>
                              {c.couponCnt} x {couponInfo.couponName}
                            </div>
                          ) : ''
                        })
                      }
                    </div>}
                  {item.couponHasAcquired && <div className='reply-tip'>{i18n.t('mkt.comment.couponHasIssued')}</div>}
                </div>
              )
            })
          }
          {notCoupons.length > 0 && <div style={{ height: '88px' }}></div>}
        </div>
      </IonContent>
      {
        notCoupons.length > 0 &&
          <div className='aquire-footer'>
            <div className='aquire-btn'>
              <span>{i18n.t('mkt.comment.haveNumCouponsClaim', { number: getCouponsInfo(notCoupons, 'cnt') })}</span>
              <MktButton
                size='small' onClick={() => {
                  getCoupons()
                }}
              >
                <span>{i18n.t('mkt.comment.getItNow')}</span>
              </MktButton>
            </div>
          </div>
      }
    </IonPage>
  )
}

export default observer(GiftCard)
